var _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoriesLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5264,
    y: 10.5263,
    width: 5.92593,
    height: 5.92593,
    rx: 1.4,
    fill: "#53B9EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5264,
    y: 19.4152,
    width: 5.92593,
    height: 5.92593,
    rx: 1.4,
    fill: "#53B9EA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.415,
    y: 10.5263,
    width: 5.92593,
    height: 5.92593,
    rx: 1.4,
    fill: "#53B9EA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.415,
    y: 19.4152,
    width: 10.3704,
    height: 10.3704,
    rx: 1.4,
    fill: "#53B9EA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoriesLogo);
export default __webpack_public_path__ + "static/media/categoriesLogo.5e2e81cb2bdf08bad5b9f9edb4017a36.svg";
export { ForwardRef as ReactComponent };